export default __webpack_public_path__ + "static/media/POP_CULTURE.f33c85bf.png";